import { render, staticRenderFns } from "./copyBottom.vue?vue&type=template&id=20c3814e&scoped=true"
import script from "./copyBottom.vue?vue&type=script&lang=js"
export * from "./copyBottom.vue?vue&type=script&lang=js"
import style0 from "./copyBottom.vue?vue&type=style&index=0&id=20c3814e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c3814e",
  null
  
)

export default component.exports